import type {
  CreateContractorRequest,
  CreateContractorResult,
  CreateContractorApiResponse,
} from "@onsemble/shared/types/internal";
import { TanstackError } from "../client";

/**
 * Create a new contractor organization
 *
 * Creates org in both Clerk and Supabase
 */
export async function createContractor(
  data: CreateContractorRequest
): Promise<CreateContractorResult> {
  const response = await fetch("/api/internal/contractors", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });

  const result: CreateContractorApiResponse = await response.json();

  if (!response.ok || !result.success) {
    throw new TanstackError(
      response.status,
      result.error || "Failed to create organization"
    );
  }

  return result.data;
}
